<template>
  <PCSettingsBlock
    v-if="hasAccessToExpeditions"
    :title="t('userConfiguration.expeditions.title')"
  >
    <PCSettingsBlockItem :title="t('userConfiguration.expeditions.showAddress')">
      <template #right>
        <f7-toggle
          v-model:checked="showAddressName"
        />
      </template>
    </PCSettingsBlockItem>
  </PCSettingsBlock>
</template>

<script setup>
// @ts-check
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useSettingRef } from '@erpagroapp/settings';
import { ModuleProcessMappings } from '@erpagroapp/common';

import PCSettingsBlock from './PCSettingsBlock.vue';
import PCSettingsBlockItem from './PCSettingsBlockItem.vue';

const { t } = useI18n();
const { availableProcessIds } = storeToRefs(useAppConfigStore());
const showAddressName = useSettingRef('Expediciones.MostrarNombreDireccion');

const EXPEDITIONS_PROCESS_ID = ModuleProcessMappings.Commercialisation.Processes.Expeditions.Id;

const hasAccessToExpeditions = computed(() => availableProcessIds.value.includes(EXPEDITIONS_PROCESS_ID));
</script>
